module.exports = __webpack_public_path__ + "media/images/apple-touch-icons/apple-touch-icon-120x120-6f25b592eb60f5443218b7f03f306c24.png";